import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Transferhistory, TransferhistoryMaintanence } from './transferhistory.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class TransferhistoryService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Transferhistory,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/transferhistory');
      let bodyContent = {"transferhistory":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
 
  findByKey(key: Transferhistory,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<Transferhistory|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transferhistory/{paymentId}');
      httpRequest.setServerContext(environment.transfersPublisher);
       httpRequest.addPathParameter('paymentId', key.paymentId);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.transferhistory ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: Transferhistory,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/transferhistory/{paymentId}');
       httpRequest.addPathParameter('paymentId', payload.paymentId);
     httpRequest.setMethod('PUT');
      let bodyContent = {"transferhistory":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   delete(payload: Transferhistory,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/transferhistory/{paymentId}');
       httpRequest.addPathParameter('paymentId', payload.paymentId);
     httpRequest.setMethod('DELETE');
      let bodyContent = {"transferhistory":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   patch(payload: Transferhistory,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): PatchFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transferhistory/{paymentId}');
       httpRequest.addPathParameter('paymentId', payload.paymentId);
     httpRequest.setMethod('PUT');
      let bodyContent = {"transferhistory":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
 findAll(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<TransferhistoryMaintanence> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transferhistory');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('GET');
      criteriaQuery.addSortCriteria('createdOn','desc','Timestamp');
      criteriaQuery.addFilterCritertia('status', 'String', 'notEqual', {
        searchText:  'I',
      });

      criteriaQuery.setPaginationCriteria('1',1000);
      httpRequest.addQueryParameter('instructionType', criteriaQuery.getQueryparam('instructionType'));
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(
          map(
            (res: IHttpSuccessPayload<TransferhistoryMaintanence>) =>{
             return{
              data:res.body?.transferhistory || [],
              totalRowCount: res.body?.totalRowCount
              }
            }
          )
        );
    };
  }
  
   
  lookup(key: any,httpOption : Map<keyof FpxIHttpOption, Map<string, any>> = new Map(), criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
    return () => {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/transferhistory');
    httpRequest.addQueryParameter('lookup', 1);
    if(criteriaQuery){
        criteriaQuery?.addFilterCritertia('text','String','Contains',{
          searchText : key.searchText
        })
        httpRequest.setCriteriaQuery(criteriaQuery)
     }
    return this._httpProvider.invokeRestApi(httpRequest,httpOption).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data || [];
        })
      );
    };
  }
  
  fetchStatistics(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/transferhistory/statistics");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
}
